import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Left_bg from "../../../assets/Group 11635.png";
import vibe_logo from "../../../assets/vibe-logo.png";
import first_step_banner from "../../../assets/first-step.svg";
import step_background_image from "../../../assets/step-background.svg";
import last_step_banner from "../../../assets/last-step.svg";
import app_store from "../../../assets/app_store.png";
import google_play from "../../../assets/google_play.png";
import "./Feedback.css";
import { ToastContainer, toast } from "react-toastify";

const Feedback = () => {
  const [searchParams] = useSearchParams();
  const storeId = searchParams.get("storeId") || "0000"; // Default to 1112 if not provided

  // const [apiurl, setapiurl] = useState("http://192.168.80.226:8002");
  const [apiurl, setapiurl] = useState("https://vibe.qbscocloud.net:8000");

  const [currentScreen, setCurrentScreen] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isValidatingPhone, setIsValidatingPhone] = useState(false);
  const [isCheckingApi, setIsCheckingApi] = useState(false);
  const [formData, setFormData] = useState({
    phoneNumber: "",
    experience: "",
    availability: "",
    productsNotAvailable: "",
    locateProducts: "",
    cleanliness: "",
    temperature: "",
    newStoreExperience: "",
    issues: "",
  });

  const validatePhoneNumber = async (phoneNumber) => {
    setIsValidatingPhone(true);
    try {
      const response = await fetch(
        `${apiurl}/web/checkFeedbackSubmission?phone=${phoneNumber}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      let result = null;
      try {
        result = await response.json();
      } catch (_) {
        /* ignore parse errors */
      }

      console.log("API Response:", result);

      // ✅ Handle case: Already submitted feedback
      if (result?.submitted) {
        toast.error(
          result?.error || "You have already submitted this feedback form",
        );
        return {
          success: false,
          alreadySubmitted: true,
          message: result?.error,
        };
      }

      // ✅ Normal success case
      if (result?.status === true || response.ok) {
        toast.success("Phone number verified");
        return { success: true, data: result };
      }

      // ❌ Other failure cases
      const errMsg =
        result?.error ||
        result?.message ||
        response.statusText ||
        "Phone verification failed. Please try again.";
      toast.error(errMsg);
      return { success: false, error: errMsg };
    } catch (error) {
      console.log("Network error:", error);
      const errMsg = error?.message || "Network error while verifying phone.";
      toast.error(errMsg);
      return { success: false, error: errMsg };
    } finally {
      setIsValidatingPhone(false);
    }
  };

  const validateScreen = async (screenNumber) => {
    const errors = [];

    switch (screenNumber) {
      case 1:
        if (!formData.phoneNumber.trim()) {
        }
        break;
      case 2:
        if (!formData.phoneNumber.trim()) {
          errors.push("Please enter your phone number.");
        } else if (!/^(03\d{9})$/.test(formData.phoneNumber.trim())) {
          errors.push("Phone number must be valid (e.g. 03001234567).");
        } else {
          const validationResult = await validatePhoneNumber(
            formData.phoneNumber,
          );
          if (!validationResult.success) return false;
        }
        break;

      case 3:
        if (!formData.experience) {
          errors.push("Please select your overall shopping experience.");
        }
        if (!formData.availability) {
          errors.push(
            "Please select whether you found all the products you came for.",
          );
        }
        break;

      case 4:
        if (!formData.productsNotAvailable.trim()) {
          errors.push(
            "Please mention any products that were unavailable in the store.",
          );
        }
        if (!formData.locateProducts) {
          errors.push(
            "Please select how easy it was to locate products in the store.",
          );
        }
        break;

      case 5:
        if (!formData.cleanliness) {
          errors.push("Please rate the cleanliness and hygiene of the store.");
        }
        if (!formData.temperature) {
          errors.push(
            "Please select your comfort level with store temperature.",
          );
        }
        break;

      case 6:
        if (!formData.newStoreExperience.trim()) {
          errors.push(
            "Please tell us what you liked most about the new store experience.",
          );
        }
        if (!formData.issues.trim()) {
          errors.push(
            "Please describe any issues you faced during your visit.",
          );
        }
        break;

      default:
        break;
    }

    if (errors.length > 0) {
      toast.error(errors.join("\n"), {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          whiteSpace: "pre-line",
          textAlign: "left",
        },
      });
      return false;
    }

    return true;
  };

  const nextScreen = async () => {
    // ✅ SPECIAL CONDITION FOR START BUTTON (screen 1 → 2)
    if (currentScreen === 1) {
      setIsCheckingApi(true);

      try {
        const response = await fetch(
          `${apiurl}/web/verifyStoreId?storeId=${storeId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          },
        );

        const statusOK = response.ok;
        const result = await response.json().catch(() => null);

        console.log("API Response:", response);
        console.log("API Result:", result);

        if (statusOK && (result?.status === true || result?.code === 200)) {
          // ✅ Proceed if response is 200 or status true
          setCurrentScreen(2);
          // toast.success("Store verified successfully!");
        } else {
          // ❌ Show error message if not OK
          toast.error(
            result?.error ||
              response.statusText ||
              "Something went wrong. Please try again.",
          );
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error(
          "Unable to connect. Please check your internet or try again later.",
        );
      } finally {
        setIsCheckingApi(false);
      }

      return; // stop here for screen 1
    }

    // ✅ NORMAL VALIDATION FOR ALL OTHER SCREENS
    const isValid = await validateScreen(currentScreen);
    if (isValid && currentScreen < 6) {
      setCurrentScreen(currentScreen + 1);
    }
  };

  const prevScreen = () => {
    if (currentScreen > 1) setCurrentScreen(currentScreen - 1);
  };

  const handleInputChange = (field, value) => {
    if (field === "phoneNumber") {
      // Automatically replace +92 prefix with 0
      const formattedValue = value.replace(/^\+92/, "0");
      setFormData((prev) => ({ ...prev, [field]: formattedValue }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const submitFeedback = async () => {
    // Ensure current screen is valid before submitting
    const isValid = await validateScreen(currentScreen);
    if (!isValid) return;

    setIsSubmitting(true);

    const formDataToSend = {
      phone: formData.phoneNumber,
      shopping_experience: formData.experience,
      found_all_products: formData.availability,
      missing_products: formData.productsNotAvailable,
      product_location_ease: formData.locateProducts,
      store_cleanliness: formData.cleanliness,
      store_temperature: formData.temperature,
      liked_most: formData.newStoreExperience,
      issues_faced: formData.issues,
      store_id: storeId,
    };

    try {
      const response = await fetch(`${apiurl}/web/saveStoreFeedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formDataToSend),
      });

      // Try to parse JSON even on non-2xx responses
      let result = null;
      try {
        result = await response.json();
      } catch (_) {
        // ignore JSON parse error; will fallback to status text
      }

      // Expecting shape: { status: true, message: "Feedback form submitted successfully" }
      const ok = result?.status === true || response.ok;

      if (!ok) {
        const errMsg =
          result?.error ||
          response.statusText ||
          "Something went wrong. Please try again.";
        toast.error(errMsg);
        return { success: false, error: errMsg };
      }

      const successMsg = result?.message || "Feedback submitted successfully";
      toast.success(successMsg);

      // Go to Thank You screen
      setCurrentScreen(7);

      // Reset to initial form shape (matching state keys used in this component)
      setFormData({
        phoneNumber: "",
        experience: "",
        availability: "",
        productsNotAvailable: "",
        locateProducts: "",
        cleanliness: "",
        temperature: "",
        newStoreExperience: "",
        issues: "",
      });

      return { success: true, data: result || {} };
    } catch (error) {
      toast.error(error?.message || "Network error. Please try again.");
      return { success: false, error: error?.message };
    } finally {
      setIsSubmitting(false);
    }
  };

  const ProgressLines = () => (
    <div className="Feedback-progress-lines">
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className={`Feedback-progress-line ${
            i < currentScreen - 1
              ? "Feedback-completed"
              : i === currentScreen - 1
                ? "Feedback-current"
                : "Feedback-future"
          }`}
        />
      ))}
    </div>
  );

  return (
    <>
      <ToastContainer />
      <div className="Feedback-main-Feedback-div">
        <div
          className="Feedback-container"
          style={{ backgroundImage: `url(${Left_bg})` }}
        >
          {/* Screen 1: Intro */}
          <div
            className={`Feedback-screen ${currentScreen === 1 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-First-Step-header">
              <div className="Feedback-First-Step-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
            </div>
            <div className="Feedback-content Feedback-intro-hero">
              <img
                src={first_step_banner}
                alt="First Step Banner"
                className="Feedback-banner"
              />
              <h2 className="Feedback-headline">
                Scan. Share. <span className="Feedback-red">Win Rs. 200!</span>
              </h2>
              <p className="Feedback-intro-text">
                Driven by our Perfect Store vision, we're working to standardize{" "}
                <strong>Vibe</strong> and <strong>Shop Stop outlets</strong>,
                creating convenient, sustainable shopping{" "}
                <strong>experiences</strong>.
              </p>
              <p className="Feedback-intro-text">
                Your <strong>feedback</strong> will help us do even better — and
                as a thank you, you'll receive{" "}
                <span className="Feedback-red">Rs. 200</span> for your next
                purchase on our <strong>e-commerce app Vibe</strong>.{" "}
                <strong>Survey takes less than 40 seconds!</strong>
              </p>
              <div className="Feedback-bottom-buttons">
                <button
                  className="Feedback-button"
                  onClick={nextScreen}
                  disabled={isCheckingApi}
                >
                  {isCheckingApi ? "Checking..." : "Start"}
                </button>
              </div>
            </div>
          </div>

          {/* Screen 2: Phone Number */}
          <div
            className={`Feedback-screen ${currentScreen === 2 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
              <ProgressLines />
            </div>
            <div className="Feedback-content">
              <h3>
                1. Your phone number to receive Rs. 200 cashback (within 24
                hours):<span className="Feedback-red">*</span>
              </h3>
              <input
                type="tel"
                placeholder="03XXXXXXXXX"
                className="Feedback-input-field"
                value={formData.phoneNumber}
                onChange={(e) =>
                  handleInputChange("phoneNumber", e.target.value)
                }
                disabled={isValidatingPhone}
              />
              <div className="Feedback-bottom-buttons">
                <button
                  className="Feedback-button Feedback-next"
                  onClick={nextScreen}
                  disabled={isValidatingPhone}
                >
                  {isValidatingPhone ? "Validating..." : "Next"}
                </button>
              </div>
            </div>
          </div>

          {/* Screen 3 */}
          <div
            className={`Feedback-screen ${currentScreen === 3 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
              <ProgressLines />
            </div>
            <div className="Feedback-content">
              <div className="Feedback-question-group">
                <h3>
                  2. How was your overall shopping experience?
                  <span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-rating-options">
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="experience"
                      value="Excellent"
                      checked={formData.experience === "Excellent"}
                      onChange={(e) =>
                        handleInputChange("experience", e.target.value)
                      }
                    />
                    Excellent
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="experience"
                      value="Good"
                      checked={formData.experience === "Good"}
                      onChange={(e) =>
                        handleInputChange("experience", e.target.value)
                      }
                    />
                    Good
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="experience"
                      value="Average"
                      checked={formData.experience === "Average"}
                      onChange={(e) =>
                        handleInputChange("experience", e.target.value)
                      }
                    />
                    Average
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="experience"
                      value="Poor"
                      checked={formData.experience === "Poor"}
                      onChange={(e) =>
                        handleInputChange("experience", e.target.value)
                      }
                    />
                    Poor
                  </label>
                </div>
              </div>

              <div className="Feedback-question-group">
                <h3>
                  3. Were you able to find all the products you came for?
                  <span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-rating-options">
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="availability"
                      value="Yes"
                      checked={formData.availability === "Yes"}
                      onChange={(e) =>
                        handleInputChange("availability", e.target.value)
                      }
                    />
                    Yes
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="availability"
                      value="No"
                      checked={formData.availability === "No"}
                      onChange={(e) =>
                        handleInputChange("availability", e.target.value)
                      }
                    />
                    No
                  </label>
                </div>
              </div>

              <div className="Feedback-bottom-buttons">
                <button className="Feedback-nav-button" onClick={prevScreen}>
                  Back
                </button>
                <button
                  className="Feedback-nav-button Feedback-next"
                  onClick={nextScreen}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          {/* Screen 4 */}
          <div
            className={`Feedback-screen ${currentScreen === 4 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
              <ProgressLines />
            </div>
            <div className="Feedback-content">
              <div className="Feedback-question-group">
                <h3>
                  4. Are there any products you wish were available in the store
                  but weren't?<span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-textarea-container">
                  <textarea
                    placeholder="Type..."
                    className="Feedback-textarea-field"
                    value={formData.productsNotAvailable}
                    onChange={(e) =>
                      handleInputChange("productsNotAvailable", e.target.value)
                    }
                    maxLength={200}
                  />
                  <div className="Feedback-character-counter">
                    {formData.productsNotAvailable.length}/200
                  </div>
                </div>
              </div>

              <div className="Feedback-question-group">
                <h3>
                  5. How easy was it to locate products in the store?
                  <span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-rating-options">
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="locate"
                      value="Very Easy"
                      checked={formData.locateProducts === "Very Easy"}
                      onChange={(e) =>
                        handleInputChange("locateProducts", e.target.value)
                      }
                    />
                    Very Easy
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="locate"
                      value="Easy"
                      checked={formData.locateProducts === "Easy"}
                      onChange={(e) =>
                        handleInputChange("locateProducts", e.target.value)
                      }
                    />
                    Easy
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="locate"
                      value="Difficult"
                      checked={formData.locateProducts === "Difficult"}
                      onChange={(e) =>
                        handleInputChange("locateProducts", e.target.value)
                      }
                    />
                    Difficult
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="locate"
                      value="Very Difficult"
                      checked={formData.locateProducts === "Very Difficult"}
                      onChange={(e) =>
                        handleInputChange("locateProducts", e.target.value)
                      }
                    />
                    Very Difficult
                  </label>
                </div>
              </div>

              <div className="Feedback-bottom-buttons">
                <button className="Feedback-nav-button" onClick={prevScreen}>
                  Back
                </button>
                <button
                  className="Feedback-nav-button Feedback-next"
                  onClick={nextScreen}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          {/* Screen 5 */}
          <div
            className={`Feedback-screen ${currentScreen === 5 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
              <ProgressLines />
            </div>
            <div className="Feedback-content">
              <div className="Feedback-question-group">
                <h3>
                  6. How would you rate the overall cleanliness and hygiene of
                  the store?<span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-rating-options">
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="cleanliness"
                      value="Excellent"
                      checked={formData.cleanliness === "Excellent"}
                      onChange={(e) =>
                        handleInputChange("cleanliness", e.target.value)
                      }
                    />
                    Excellent
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="cleanliness"
                      value="Good"
                      checked={formData.cleanliness === "Good"}
                      onChange={(e) =>
                        handleInputChange("cleanliness", e.target.value)
                      }
                    />
                    Good
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="cleanliness"
                      value="Average"
                      checked={formData.cleanliness === "Average"}
                      onChange={(e) =>
                        handleInputChange("cleanliness", e.target.value)
                      }
                    />
                    Average
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="cleanliness"
                      value="Poor"
                      checked={formData.cleanliness === "Poor"}
                      onChange={(e) =>
                        handleInputChange("cleanliness", e.target.value)
                      }
                    />
                    Poor
                  </label>
                </div>
              </div>

              <div className="Feedback-question-group">
                <h3>
                  7. Was the store temperature comfortable during your visit?
                  <span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-rating-options">
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="temperature"
                      value="Yes, it was perfectly comfortable"
                      checked={
                        formData.temperature ===
                        "Yes, it was perfectly comfortable"
                      }
                      onChange={(e) =>
                        handleInputChange("temperature", e.target.value)
                      }
                    />
                    Yes, it was perfectly comfortable
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="temperature"
                      value="It felt slightly warm"
                      checked={formData.temperature === "It felt slightly warm"}
                      onChange={(e) =>
                        handleInputChange("temperature", e.target.value)
                      }
                    />
                    It felt slightly warm
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="temperature"
                      value="It was too hot and stuffy"
                      checked={
                        formData.temperature === "It was too hot and stuffy"
                      }
                      onChange={(e) =>
                        handleInputChange("temperature", e.target.value)
                      }
                    />
                    It was too hot and stuffy
                  </label>
                  <label className="Feedback-rating-option">
                    <input
                      type="radio"
                      name="temperature"
                      value="It was too cold"
                      checked={formData.temperature === "It was too cold"}
                      onChange={(e) =>
                        handleInputChange("temperature", e.target.value)
                      }
                    />
                    It was too cold
                  </label>
                </div>
              </div>

              <div className="Feedback-bottom-buttons">
                <button className="Feedback-nav-button" onClick={prevScreen}>
                  Back
                </button>
                <button
                  className="Feedback-nav-button Feedback-next"
                  onClick={nextScreen}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          {/* Screen 6 */}
          <div
            className={`Feedback-screen ${currentScreen === 6 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
              <ProgressLines />
            </div>
            <div className="Feedback-content">
              <div className="Feedback-question-group">
                <h3>
                  8. What did you like most about the new store experience?
                  <span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-textarea-container">
                  <textarea
                    placeholder="Type..."
                    className="Feedback-textarea-field"
                    value={formData.newStoreExperience}
                    onChange={(e) =>
                      handleInputChange("newStoreExperience", e.target.value)
                    }
                    maxLength={200}
                  />
                  <div className="Feedback-character-counter">
                    {formData.newStoreExperience.length}/200
                  </div>
                </div>
              </div>

              <div className="Feedback-question-group">
                <h3>
                  9. Did you face any issues during your visit that you'd like
                  to report (e.g., staff behavior, cleanliness)? Please let us
                  know.<span className="Feedback-red">*</span>
                </h3>
                <div className="Feedback-textarea-container">
                  <textarea
                    placeholder="Type..."
                    className="Feedback-textarea-field"
                    value={formData.issues}
                    onChange={(e) =>
                      handleInputChange("issues", e.target.value)
                    }
                    maxLength={200}
                  />
                  <div className="Feedback-character-counter">
                    {formData.issues.length}/200
                  </div>
                </div>
              </div>

              <div className="Feedback-bottom-buttons">
                <button className="Feedback-nav-button" onClick={prevScreen}>
                  Back
                </button>
                <button
                  className="Feedback-nav-button Feedback-next"
                  onClick={submitFeedback}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>

          {/* Screen 7 */}
          <div
            className={`Feedback-screen ${currentScreen === 7 ? "Feedback-active" : ""}`}
          >
            <div className="Feedback-header">
              <div className="Feedback-logo-container">
                <img
                  src={vibe_logo}
                  alt="Vibe Logo"
                  className="Feedback-logo"
                />
              </div>
            </div>
            <div className="Feedback-content Feedback-thank-you">
              <img
                src={last_step_banner}
                alt="Last Step Banner"
                className="Feedback-Last-banner"
              />
              <h2>Thankyou for the Feedback!</h2>
              <p>
                Download the app to claim your <strong>Reward!</strong>
              </p>
              <div className="Feedback-app-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.vibe_app&pcampaignid=web_share"
                  className="Feedback-app-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={google_play} alt="Google Play" />
                </a>

                <a
                  href="https://apps.apple.com/pk/app/vibe-pso/id6503432941"
                  className="Feedback-app-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={app_store} alt="App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Feedback;
